import * as $ from "jquery";

export default class ContactsMap {
    constructor() {
        this.mapPreviewId = 'location_map_preview';
        this.$preview = document.getElementById(this.mapPreviewId);
        if (!this.$preview) return false;

        try {
            this.settings = JSON.parse(this.$preview.dataset['settings']);
            this.coords = this.settings.coords.split(',');
            this.points = this.settings.points;
            this.mapPreview = null;
            this.map = null;

            this.init();
        } catch (e) {
            console.log(e);
        }
    }

    init() {
        this.initMap(this.mapPreviewId).then(map => this.mapPreview = map);
    }

    initMap(id) {
        return new Promise(resolve => {
            ymaps.ready(() => {
                const map = new ymaps.Map(id, {
                    center: this.coords,
                    controls: [],
                    zoom: 14
                }, {
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true
                });

                map.behaviors.disable('scrollZoom');
                map.behaviors.disable('dblClickZoom');
                map.behaviors.disable('multiTouch');

                this.points.features = this.points.features.map(item => {
                    let baloon = ymaps.templateLayoutFactory.createClass(
                        `<div class="balloon-map">
                            <span>${item.properties.balloonContent}</span>
                            <i class="close icon-close"></i>
                        </div> `
                    );
                    let circleLayout = ymaps.templateLayoutFactory.createClass(`
                        <div class="placemark_layout_container" style="background: ${item.options.fillColor};width:32px;height: 32px;border-radius: 50%; background-image: url(${item.options.iconImageHref})"></div>
                        `);
                    return {
                        ...item,
                        options: {
                            ...item.options,
                            iconLayout: circleLayout,
                            iconShape: {
                                type: 'Circle',
                                // Круг описывается в виде центра и радиуса
                                coordinates: [0, 0],
                                radius: 32
                            },
                            balloonLayout: baloon
                        }
                    }
                })
                console.log(this.points)
                // Создадим объекты из их JSON-описания и добавим их на карту.
                window.myObjects = ymaps.geoQuery(this.points).addToMap(map);

                $('body').on('click', '.balloon-map .close', (e) => {
                    map.balloon.close();
                })

                $(window).on('resize', function() {
                    map.container.fitToViewport();
                })

                // зум только для фулскринной карты
                if (id !== 'location_map') {
                    map.behaviors.disable('scrollZoom');
                }

                resolve(map);
            });
        })
    }
}
